import RestClient from "RestClient";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const restClient = new RestClient();

export const getAgentList = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/agents`,payload);
    return result?.data; 
}


export const addAgent = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/agents/create`, payload);
    return result; 
}

export const updateAgent = async (id, payload) => {
    const result = await restClient.put(`${BASE_URL}/agents/${id}`, payload);
    return result; 
}

export const getSingleAgent = async (id) => {
    const result = await restClient.get(`${BASE_URL}/agents/${id}`);
    return result?.data; 
}

export const sendNewAccountEmail = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/agents/sendEmail`,payload);
    return result?.data; 
}
